import jsPDF from 'jspdf';
import 'jspdf-autotable';

export function testPdf() {
  const doc = new jsPDF();
  doc.text('Prueba PDF', 14, 22);
  doc.autoTable({
    head: [['Columna 1', 'Columna 2']],
    body: [['Dato 1', 'Dato 2']],
    startY: 30
  });
  doc.save('prueba.pdf');
}